<template>
    <frm-calendar-appointment-mail-notification-warning
        :birthdate="birthdate"
        dismiss-on-complete
        :has-email="hasEmail"
        mail-context="invoice"
        :patient-age="patientAge"
        :patient-id="patientId"
        :permission-both-parents-required="permissionBothParentsRequired"
        :permissions="permissions"
        presentation="modal"
        @cancelled="cancel"
        @dismissed="close"
    />
</template>

<script>
import ModalManager from '../../services/modalManager';

export default {
    props: {
        patientId: {
            type: String,
            required: true,
        },
        patientAge: {
            type: Number,
            default: null,
        },
        birthdate: {
            type: String,
            default: null,
        },
        permissions: {
            type: Object,
            required: true,
        },
        hasEmail: {
            type: Boolean,
            required: true,
        },
        permissionBothParentsRequired: {
            type: Boolean,
            required: true,
        },
    },

    methods: {
        cancel() {
            ModalManager.closeModal();
        },

        close() {
            ModalManager.closeModal({ refresh: true });
        },
    },
};
</script>
